import { useRoutes, Navigate } from "react-router-dom";
import { AuthLayout } from "../layouts/AuthLayout";
import { BaseLayout } from "../layouts/BaseLayout";
import { Login } from "../pages/authentication/Login";
import { ResetPassword } from "../pages/authentication/ResetPassword";
import Services from "../pages/demo";
import { ForgotPassword } from "../pages/authentication/ForgotPassword";
import PaymentPage from "../pages/payment";
import { MyVocabulary } from "../pages/myVocabulary";
import { MyLibrary } from "../pages/myLibrary";
import { LibraryView } from "../pages/myLibrary/libraryView";
import { GrammerBook } from "../pages/grammerBook";
import { GrammerBookView } from "../pages/grammerBook/grammerBookView";
import { MyAnswers } from "../pages/myAnswers";
import { Questions } from "../pages/myAnswers/questions";
import { AnswerDetails } from "../pages/answerDetails/answerDetails";
import { Feedbacks } from "../pages/feedbacks";
import { FeedbackQuestions } from "../pages/feedbacks/feedbackQuestions";
import { RegistrationCompleted } from "../pages/authentication/RegitsrationCompleted";

const Router = () => {
  const courseType = localStorage.getItem("courseType");
  const checkCourseType = courseType === "Non-Test Based";
  const routes = [
    {
      path: "/",
      element: <AuthLayout />,
      children: [
        {
          path: "/",
          element: <Login />,
        },
        {
          path: "/forgot-password",
          element: <ForgotPassword />,
        },
        {
          path: "/reset-password",
          element: <ResetPassword />,
        },
        {
          path: "/registration-completed",
          element: <RegistrationCompleted />,
        },
      ],
    },
    {
      path: "/student",
      element: <BaseLayout />,
      children: [
        {
          path: "dashboard",
          element: <Services />,
        },
        {
          path: "my-vocabulary",
          element: <MyVocabulary />,
        },
        {
          path: "my-library",
          element: <MyLibrary />,
        },
        {
          path: "my-library/:id",
          element: <LibraryView />,
        },
        {
          path: "grammar-book",
          element: checkCourseType ? <GrammerBook /> : <GrammerBook />,
        },
        {
          path: "my-grammar-book/:id",
          element: checkCourseType ? <GrammerBookView /> : <GrammerBookView />,
        },
        {
          path: "my-answers",
          element: checkCourseType ? <MyAnswers /> : <MyAnswers />,
        },
        {
          path: "my-answer-questions/:date",
          element: checkCourseType ? <Questions /> : <Questions />,
        },
        {
          path: "my-answer-details/:id",
          element: checkCourseType ? <AnswerDetails /> : <AnswerDetails />,
        },
        {
          path: "feedbacks",
          element: checkCourseType ? <Feedbacks /> : <Feedbacks />,
        },
        {
          path: "feedback-questions/:date",
          element: checkCourseType ? <FeedbackQuestions /> : <FeedbackQuestions />,
        },
      ],
    },
    {
      path: "/student",
      element: <AuthLayout />,
      children: [
        {
          path: "payment",
          element: <PaymentPage />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/" />,
    },
  ];

  let element = useRoutes(routes);

  return element;
};

export default Router;
